import { gql } from '@apollo/client';

const GET_PAYMENT_METHOD_SECTION = gql`
  query GetSectionBySlug($slug: String!) {
    sectionsBy(slug: $slug) {
      paymentMethodSection {
        tituloPM
        subtituloMovil
      }
    }
  }
`;

export { GET_PAYMENT_METHOD_SECTION }